import axios from 'axios'

const defaultOptions = {
  baseURL: process.env.NODE_ENV === 'development' ? 'http://localhost:8080/' : 'https://videocvpage.herokuapp.com',
  headers: {
    'Content-Type': 'application/json',
  },
}

export const instance = axios.create(defaultOptions)